import { Report } from "../../Interfaces/TableInterfaces";
import {
  OrderBookReport,
  OrderBookSearchParam,
} from "../../Interfaces/orderBookSamplingInterfaces";
import { getTable } from "../requestTemplates";

export const getSamplingTable = async (
  searchParam: OrderBookSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<OrderBookReport>> =>
  getTable<OrderBookSearchParam, OrderBookReport>(
    "/v1/general/samplingTable",
    searchParam,
    offset,
    pageSize
  );
